<div class="container containerSteps my-5">
  <div
    class="containerStep"
    *ngFor="let stp of steps"
    [ngClass]="{
      stepActive: stp.stepid === stepInt,
      hidden:
        stp.stepid <= stepInt - 2 ||
        (stepInt == 1 && stp.stepid > 5) ||
        (stepInt > 1 && stp.stepid >= stepInt + 2)
    }"
  >
    <div class="stepIcon">
      <fa-icon [icon]="stp.icon" transform="grow-6 up-3"></fa-icon>
    </div>
    <h3 class="stepTitle">{{ stp.title }}</h3>
    <div class="stepDescrip">{{ stp.description }}</div>
    <button
      *ngIf="stp.stepid === stepInt"
      type="button"
      class="buttonPortal lg my-4"
      mat-raised-button
      (click)="redirect($event)"
    >
      <span>{{ 'k000226' | translate }}</span>
    </button>
  </div>
</div>
